export default {
  title: 'Raport echipă vânzări',
  fields: {
    name: 'Nume',
    area: 'Zonă',
    signed: 'Semnat',
    live: 'Live',
  },
  buttons: {
    download_report: 'Descarcă raport',
  },
  toasts: {
    failed_to_load_data: 'Eroare la încărcarea datelor, vă rugăm reîncărcați pagina',
  },
};
